import { INSTA_POST_ENGAGEMENT } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function instaEngagement(state=INITIAL_STATE, action) {
 
  switch(action.type) {
    case INSTA_POST_ENGAGEMENT:
     
      // const parsedData = JSON.parse(action.payload.data)
     console.log("THE POST ENGAGEMENT DATA",action.payload)
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}
